<template>
  <Dashboard grafana-path="/d/euFgrNuGz/seatbelt" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "SeatbeltPage",

  routing: {
    localizationKey: "menu.tab.seatbelt_driver",
    icon: "mdi-table",
    path: "/seatbelt",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
